<div
  *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
  <div class="row mt-4 ">
    <div class="col ">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
              agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
  <div class="col-12">
    <h4 class="mb-2 font-header-1">Ticket</h4>
  </div>
  <div class="col-12 mt-3 p-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-header transparent">
        <div class="row">
          <div class="col-3">
            <div class="col">
              <label class="fs-size">Status</label>
            </div>
            <div class="col mt-1">
              <ng-select [searchable]="true" [(ngModel)]="ListSendBO.statusLid" (ngModelChange)="Search()"
                [clearable]="true" [items]="StatusList" bindLabel="lovName" class="tdropdown" bindValue="id">
              </ng-select>
            </div>
          </div>
          <div class="col-3">
            <div class="col">
              <label class="fs-size">Priority</label>
            </div>
            <div class="col mt-1">
              <ng-select [searchable]="true" [(ngModel)]="ListSendBO.priorityLid" (ngModelChange)="Search()"
                [clearable]="true" [items]="PriorityList" bindLabel="lovName" class="tdropdown" bindValue="id">
              </ng-select>
            </div>
          </div>
          <div class="col-3">
            <div class="col">
              <label class="fs-size">Type</label>
            </div>
            <div class="col mt-1">
              <ng-select [searchable]="true" [(ngModel)]="ListSendBO.ticketTypeLid" (ngModelChange)="Search()"
                [items]="TypesList" bindLabel="lovName" class="tdropdown" [clearable]="true" bindValue="id">
              </ng-select>
            </div>
          </div>
          <div class="col-3">
            <div class="col">
              <label class="fs-size">Assignee</label>
            </div>
            <div class="col mt-1">

              <ng-select [searchable]="true" [(ngModel)]="ListSendBO.employeeId" (ngModelChange)="Search()"
                [items]="EmployeeDropdown" bindLabel="Value" class="tdropdown" [clearable]="true" bindValue="Key">
              </ng-select>
            </div>
          </div>

        </div>
        <div class="row mt-1" *ngIf="this.clientTab !== 'clienttab'">
          <div class="col-3">
            <div class="col">
              <label class="fs-size">Client</label>
            </div>
            <div class="col mt-1">
              <ng-select [searchable]="true" [(ngModel)]="ListSendBO.clientId" (ngModelChange)="Search()" [disabled] = "clientTab == 'clienttab'"
                [clearable]="true" [items]="AllClientDropDownListwithStatus" bindLabel="Value" class="tdropdown" bindValue="Key">
              </ng-select>
            </div>
          </div>
          
        </div>
        <div class="row mt-2">
          <div class="col-lg-12">
            <button *ngIf="fp?.ticketCreate" type="button" class="btn blue-btn btn-sm me-2" data-bs-toggle="modal" data-bs-target="#modal"
              (click)="AddManualEntry()">Create Ticket</button>
            <button type="button" class="btn blue-btn btn-sm " style="float: right;" (click)="Refresh()">
              <i class="fa fa-repeat"> Refresh </i>
            </button>
          </div>
        </div>

      </div>
      <div class="card-body transparent">

        <div class="row mt-2 pt-1">
          <div class="col-12">
            <ejs-grid #grid id='grid' [dataSource]="GridDataList | async" [allowResizing]='true'
              [enablePersistence]="true" [allowReordering]="true" allowPaging='true' [allowFiltering]='true'
              [allowSorting]='true' [textWrapSettings]='wrapSettings'
              (dataStateChange)='dataStateChange($event)' [pageSettings]='initialPage' [filterSettings]='filterOptions'
              (actionComplete)="onActionComplete($event)" [showColumnChooser]='true'>

              <e-columns>

                <e-column width=100 headerText='Actions' uid="action" [showInColumnChooser]='false'>
                  <ng-template #template let-data>
                    <button *ngIf="fp?.ticketEdit"  class="btn btn-edit-table Ationsubbtn" data-bs-toggle="modal"
                      (click)="edittickets(data,$event)"><i class="fa fa-edit"></i></button> &nbsp;&nbsp;

                  </ng-template>
                  <!-- (click)="edittimesheet(data,$event)" -->
                </e-column>
                <e-column field='uniqueTicketId' headerText="Ticket Id" width=160 textAlign='left'
                  [allowEditing]='false' type='string'>
                  <ng-template #template let-data>
                    <div class="d-flex align-items-center">
                      <span class="text-truncate d-inline-block" style="width: 160px;">
                        {{ data.uniqueTicketId }}
                      </span>
                      <button class="btn btn-sm btn-light ms-2" (click)="copyToClipboard(data.uniqueTicketId)">
                        <i class="fa fa-copy"></i>
                      </button>
                    </div>                    
                  </ng-template>
                </e-column>
                <e-column field='title' headerText="Title" width=160 textAlign='left' [allowEditing]='false'
                  type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>

                <e-column field='statusLovName' headerText="Status" textAlign='left' width=100 [allowEditing]='false'
                  type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>



                <e-column field='priorityLovName' headerText="Priority" width=130 textAlign='left'
                  [allowEditing]='false' type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field='ticketTypeLovName' headerText="Type" width=120 textAlign='left'
                  [allowEditing]='false' type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field='employeeName' headerText="Assignee" width=90 textAlign='center'
                  [allowEditing]='false' type='string' [allowSorting]='false'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field='createdTime' headerText="Created Date" width=170 textAlign='left'
                  [format]='formatOptions' [allowEditing]='false' type='date' [allowFiltering]='false'>
                </e-column>
                <e-column field='modifiedTime' headerText="Last Modified Date" width=170 textAlign='left'
                  [format]='formatOptions' [allowEditing]='false' [allowFiltering]='false' type='date'>
                </e-column>
                <e-column field='createdBy' headerText="Created by" width=130
                textAlign='center' [allowEditing]='false' type='string'
                [allowSorting]='false'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox
                        placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column>
            <e-column field='modifiedBy' headerText="Modified by" width=130
                textAlign='center' [allowEditing]='false' type='string'
                [allowSorting]='false'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox
                        placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column>

                <e-column width="50" [showInColumnChooser]='false'>
                  <ng-template #headerTemplate let-data>
                    <div class="d-none d-lg-block">
                      <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                        </i></span>
                    </div>
                  </ng-template>
                </e-column>

              </e-columns>
            </ejs-grid>
          </div>
          <div class="col-lg-12">
            <div *ngIf="TicketsList.length == 0" class="text-center" style="color:red">
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Alert -->
<span id="OpenDeletetickets" data-bs-toggle="modal" data-bs-target="#Deletetickets"></span>
<div class="modal fade modalbackgrod" id="Deletetickets" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Delete</h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        Are you sure want to delete this ticket?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>



